<template>
  <el-row>
    <el-col :span="12">
      <div class="banner-uploader">
        <el-upload
          :headers="uploadConfig.headers"
          :action="uploadConfig.api"
          list-type="picture-card"
          :file-list="banners"
          :on-success="handleAvatarSuccess"
          :on-error="handleAvatarError"
          :before-upload="beforeAvatarUpload"
        >
          <i slot="default" class="el-icon-plus"></i>
          <div class="banner-item" slot="file" slot-scope="{ file }">
            <img
              class="el-upload-list__item-thumbnail"
              :src="file && file.imageURL"
              alt
            />
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-preview"
                @click="handlePictureCardPreview(file)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>
              <span
                class="el-upload-list__item-delete"
                @click="handleRemove(file)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
        <span style="color: #999999; font-size: 12px">
          Banner横幅的建议尺寸是：1200×400
        </span>
      </div>
    </el-col>
    <el-dialog :visible.sync="dialogVisible" :fullscreen="true">
      <img width="100%" :src="dialogImageUrl" />
    </el-dialog>
  </el-row>
</template>

<script>
import {
  deleteStoreBanner,
  getStoreBannerList,
  postStoreBanner
} from '@/api/appStore';
import { getToken } from '@/utils/auth';
import { errorHandle } from '@/utils/error';

export default {
  name: 'StoreSettings',
  created() {
    this.loadBannerList();
  },
  data() {
    let baseDomain = process.env.BASE_API;
    if (baseDomain == '/') {
      baseDomain = window.location.origin;
    }
    return {
      uploadConfig: {
        api: `${baseDomain}/app-server/uploads/picture`,
        headers: {
          Authorization: getToken()
        }
      },
      banners: [],
      dialogVisible: false,
      dialogImageUrl: ''
    };
  },
  computed: {
    marketID() {
      return this.$store.state.enterprise.enterpriseInfo.marketID;
    }
  },
  methods: {
    loadBannerList() {
      getStoreBannerList({ marketID: this.marketID }).then((re) => {
        this.banners = re.banners;
      });
    },
    handleAvatarSuccess(res, file) {
      postStoreBanner({
        marketID: this.marketID,
        imageURL: res.FileURL,
        title: ''
      }).then((re) => {
        this.loadBannerList();
        this.$message.success('Banner上传成功');
      });
    },
    handleAvatarError(re) {
      if (re.code == 10024) {
        this.$message.error(
          '上传图片类型不支持，请上传以.png .jpg .jpeg 结尾的图片'
        );
        return;
      }
      this.$message.error('上传失败!');
      this.dialogVisible = false;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPng) {
        this.$message.error('上传Banner图只能是 JPG、PNG格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传Banner图大小不能超过 2MB!');
      }
      const canUpload = (isJPG || isPng) && isLt2M;
      return canUpload;
    },
    handleRemove(banner) {
      this.$confirm('确认要删除Banner图吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteStoreBanner({
            marketID: this.marketID,
            bannerID: banner.bannerID
          })
            .then(() => {
              this.$message.success('删除成功');
              this.loadBannerList();
            })
            .catch((err) => {
              errorHandle(err);
            });
        })
        .catch(() => {});
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.imageURL;
      this.dialogVisible = true;
    },
    handleDownload(file) {}
  }
};
</script>

<style lang="scss" scoped>
.banner-uploader {
  border-radius: 10px;
}
::v-deep .banner-uploader .el-upload {
  width: 100%;
}
::v-deep .banner-uploader .el-upload-list--picture-card .el-upload-list__item {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/BannerManage/index.vue